import React from 'react';

import ProcurementIntegrationCardList from '../../AllIntegrations/ProcurementIntegrationCardList';

function ProcurementProvider() {
  return <ProcurementIntegrationCardList isCentered={true} />;
}

export default ProcurementProvider;
